<script setup lang="ts">
import AssistantMessage from '@/components/assistant/chat/message/AssistantMessage.vue'
import AssistantMessagePending from '@/components/assistant/chat/message/AssistantMessagePending.vue'
import SystemMessage from '@/components/assistant/chat/message/SystemMessage.vue'
import SystemMessageInfo from '@/components/assistant/chat/message/SystemMessageInfo.vue'
import UserMessage from '@/components/assistant/chat/message/UserMessage.vue'
import type {Message, UserMessageContent} from '@/client/mentor/MessagesClient'
import {AssistantMessageStatus, ConversationMessageType} from '@/client/mentor/MessagesClient'

defineEmits<{
  selectPreviousMessage: [content: UserMessageContent]
  selectSuggestion: [suggestion: string]
}>()

defineProps<{
  disabled?: boolean
  isLastMessage?: boolean
  message: Message
  previousMessage?: Message
}>()
</script>

<template>
  <UserMessage v-if="message.type === ConversationMessageType.USER" class="ml-auto" :message="message" />

  <!-- Assistant message -->
  <template v-else-if="message.type === ConversationMessageType.ASSISTANT">
    <!-- Pending state -->
    <AssistantMessagePending
      v-if="message.content.status === AssistantMessageStatus.PENDING"
      :is-last-message="isLastMessage"
      :message="message"
    />

    <!-- Resolved state -->
    <AssistantMessage
      v-else
      :disabled="disabled"
      :is-last-message="isLastMessage"
      :message="message"
      @select-suggestion="$emit('selectSuggestion', $event)"
    />
  </template>

  <!-- System message -->
  <template v-else-if="message.type === ConversationMessageType.SYSTEM">
    <SystemMessage
      v-if="isLastMessage"
      :disabled="disabled"
      :message="message"
      :previous-message="previousMessage"
      @select-previous-message="$emit('selectPreviousMessage', $event)"
    />

    <SystemMessageInfo v-else :message="message" />
  </template>
</template>
